import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Suppliers
export const listSuppliers = () => api.get("/suppliers").then(r => r.data);
export const createSupplier = (data) => api.post("/suppliers", data).then(r => r.data);
export const updateSupplier = (id, data) => api.patch(`/suppliers/${id}`, data).then(r => r.data);
export const deleteSupplier = (id) => api.delete(`/suppliers/${id}`).then(r => r.data);

// Products
export const listProducts = (params = {}) => api.get("/products", { params }).then(r => r.data);
export const getCategories = () => api.get("/products/categories").then(r => r.data);
export const createProduct = (data) => api.post("/products", data).then(r => r.data);
export const updateProduct = (id, data) => api.patch(`/products/${id}`, data).then(r => r.data);
export const deleteProduct = (id) => api.delete(`/products/${id}`).then(r => r.data);

// Movements
export const listMovements = (params = {}) => api.get("/movements", { params }).then(r => r.data);
export const createMovement = (data) => api.post("/movements", data).then(r => r.data);

// Stats
export const dashboardStats = () => api.get("/stats/dashboard").then(r => r.data);
export const consumptionChart = (params = {}) => api.get("/stats/consumption", { params }).then(r => r.data);

// Orders
export const orderSuggestions = () => api.get("/orders/suggestions").then(r => r.data);
export const createOrder = (data) => api.post("/orders", data).then(r => r.data);
export const listOrders = () => api.get("/orders").then(r => r.data);
export const orderPdfUrl = (id) => `${API}/orders/${id}/pdf`;
export const sendOrderEmail = (id, data) => api.post(`/orders/${id}/email`, data).then(r => r.data);

// Inventory
export const createInventoryCount = (data) => api.post("/inventory/counts", data).then(r => r.data);
export const listInventoryCounts = () => api.get("/inventory/counts").then(r => r.data);

// Excel
export const exportProductsUrl = () => `${API}/products/export/excel`;
export const templateProductsUrl = () => `${API}/products/template/excel`;
export const importProducts = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post("/products/import/excel", fd, { headers: { "Content-Type": "multipart/form-data" } }).then(r => r.data);
};
